var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmex = function SvgAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26A6D1",
    d: "M2.498 5.837H37.47a2.5 2.5 0 0 1 2.498 2.499v23.73a2.5 2.5 0 0 1-2.498 2.499H2.498A2.5 2.5 0 0 1 0 32.067V8.336a2.5 2.5 0 0 1 2.498-2.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.447 15.829 2.5 24.563h4.725l.586-1.393H9.15l.585 1.393h5.201V23.5l.464 1.063h2.69l.463-1.085v1.085H29.37l1.315-1.357 1.231 1.357 5.556.011-3.96-4.354 3.96-4.391h-5.47l-1.28 1.331-1.193-1.331H17.764l-1.01 2.254-1.035-2.254h-4.715v1.026l-.524-1.026zm.914 1.24h2.303l2.618 5.923v-5.923h2.523l2.022 4.247 1.864-4.247h2.51v6.267h-1.527l-.013-4.91-2.227 4.91h-1.366l-2.24-4.91v4.91h-3.142l-.596-1.405H6.872l-.595 1.404H4.593zm15.238 0h6.211l1.9 2.052 1.96-2.052h1.9l-2.886 3.15 2.886 3.114h-1.986l-1.9-2.076-1.97 2.076h-6.115zm-14.117 1.06-1.06 2.503H9.54zm15.65.238v1.144h3.39v1.275h-3.39v1.249h3.801l1.766-1.84-1.69-1.83h-3.876z"
  })));
};
export default SvgAmex;